import { Component, OnInit } from '@angular/core';
import { WeatherCurrentWidgetComponent } from '../../weather-current-widget/weather-current-widget.component';
import { Router } from '@angular/router';
import { ClientService, Page, CurrentWeatherObject, WeatherService, ModalService } from '@app/services';
import { I18nPipe } from '@app/shared/pipes/i18n.pipe';

@Component({
  selector: 'app-weather-current-widget-vertical',
  templateUrl: './weather-current-widget-vertical.component.html',
  styleUrls: ['./weather-current-widget-vertical.component.css']
})
export class WeatherCurrentWidgetVerticalComponent extends WeatherCurrentWidgetComponent implements OnInit {

  constructor(
    protected router: Router,
    protected weatherService: WeatherService,
    protected clientService: ClientService,
    protected i18n: I18nPipe,
    protected modalService: ModalService
  ) {
    super(router, weatherService, clientService, i18n, modalService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
